var React = require('react');

function Coins (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#73004C","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M9 23.4c1.1429.9 2.9714 1.6 4.2286 1.6C15.2857 25 17 23.7 17 22s-1.8286-2.4-3.7714-3c-2.0572-.6-3.3143-1.3-3.3143-3s1.7143-3 3.7714-3c1.3715 0 2.7429.7 3.3143 1.6M13 11v16M12 5c2-2 4.1485-3 7.6139-3C25.9505 2 31 7.1 31 13.5c0 3.4-1.6238 6.4-4 8.5m-3-3c0 6.0751-4.9249 11-11 11S2 25.0751 2 19 6.9249 8 13 8s11 4.9249 11 11Z"}));
}

Coins.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = Coins;

Coins.default = Coins;
